import React, { useEffect, useRef } from "react";
import * as UTIF from "utif";

const TiffViewer = ({ data }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!data || !canvasRef.current) return;

    try {
      // Base64 -> ArrayBuffer
      const binary = atob(data);
      const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
      const buffer = bytes.buffer;

      // Decode TIFF
      const ifds = UTIF.decode(buffer);
      UTIF.decodeImage(buffer, ifds[0]);
      const rgba = UTIF.toRGBA8(ifds[0]);

      const originalWidth = ifds[0].width;
      const originalHeight = ifds[0].height;

      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");

      // Get available space from parent
      const availableWidth = canvas.parentElement.clientWidth;

      // Scale to fit
      const scale = Math.min(availableWidth / originalWidth, 1);

      const width = Math.round(originalWidth * scale);
      const height = Math.round(originalHeight * scale);

      // Create temporary canvas
      const tempCanvas = document.createElement("canvas");
      tempCanvas.width = originalWidth;
      tempCanvas.height = originalHeight;

      const tempCtx = tempCanvas.getContext("2d");

      const imageData = tempCtx.createImageData(originalWidth, originalHeight);

      imageData.data.set(rgba);
      tempCtx.putImageData(imageData, 0, 0);

      // Draw scaled image
      canvas.width = width;
      canvas.height = height;

      ctx.clearRect(0, 0, width, height);

      ctx.drawImage(
        tempCanvas,
        0,
        0,
        originalWidth,
        originalHeight,
        0,
        0,
        width,
        height,
      );
    } catch (err) {
      console.error(err);
    }
  }, [data]);

  return <canvas ref={canvasRef} />;
};

export default TiffViewer;
